import { OwnerType as ProtoOwnerType } from '@vendasta/protos/sms/v2/enums';
import { OwnerType } from '@vendasta/smsv2';

/**
 * Translates the deprecated v1 owner type into the v2 one the generated SDK expects.
 *
 * It lives in its own module because both RegistrationService and A2PRegistrationService
 * need it, and the former already imports the latter — sharing it through either service
 * would make those two modules import each other.
 */
export function toProtoOwnerType(ownerType: OwnerType): ProtoOwnerType {
  switch (ownerType) {
    case OwnerType.OWNER_TYPE_ACCOUNT_GROUP:
      return ProtoOwnerType.OWNER_TYPE_ACCOUNT_GROUP;
    case OwnerType.OWNER_TYPE_PARTNER:
      return ProtoOwnerType.OWNER_TYPE_PARTNER;
    default:
      return ProtoOwnerType.OWNER_TYPE_UNSPECIFIED;
  }
}
